export default "__VITE_ASSET__IOTzqAtl__"